var path = '/templates/zenclerk_s/directives/notification/timezone.html';
var html = "<div ng-if=\"vm.isTimezoneDiff && vm.showAlert\" class=text-center ng-class=\"{'fixed-bottom': !vm.static}\"><div class=\"alert alert-dismissible inline-block\" ng-class=\"{'alert-warning': vm.status === 'warning', 'alert-danger': vm.status === 'danger'}\" role=alert><span class=\"fa fa-warning\"></span> <span translate=directives.notification.timezoneDifferenceWarning translate-value-timezone=\"{{ vm.project.region | gmtNotation }}\"></span> <button type=button class=\"btn btn-close btn-close--small\" data-dismiss=alert aria-label=Close ng-click=vm.hideAlert()></button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/notification/timezone.html
// module id = 1349
// module chunks = 0